export function getIsEmail(email: string) {
  const match = email.match(/^.+@.+\..+$/);
  return match ? match?.length > 0 : false;
}
